import { Collection, Model } from 'backbone';


const Documents = Collection.extend({
    /** Gets the list of attached documents to send to Joinos.
   * @returns {Array} - The array of document IDs to upload.
   */
  documentIds() {
    return this.map(doc => doc.id);
  }
});


const SMSMessage = Model.extend({
  defaults: {
    text: ''
  }
});


const JoinosMessage = Model.extend({
  defaults() {
    return {
      documents: new Documents(),
      text: '',
      title: ''
    };
  },

  /** Gets the list of attached documents to send to Joinos.
   * @returns {Array} - The array of document IDs to upload.
   */
  documentIds() {
    return this.get('documents').documentIds();
  }
});


export const MessageModel = Model.extend({
  url: '/messaging/api/messages/?format=json',

  defaults() {
    return {
      sms: new SMSMessage(),
      joinos: new JoinosMessage(),
      use_sms: true,
      use_joinos: false
    };
  },

  toJSON() {
    const rtn = this.pick('contacts');
    const config = this.pick('use_sms', 'use_joinos');
    const data = this.pick('sms', 'joinos');

    if (config.use_sms) {
      rtn.sms = data.sms.toJSON();
    }

    if (config.use_joinos) {
      rtn.joinos = data.joinos.toJSON();
      rtn.joinos.documents = this.getDocuments();
    }

    return rtn;
  },

  /** Return a list of document IDs for upload.
   * @returns {Array} - The document IDs to upload.
   */
  getDocuments() {
    return this.get('joinos').documentIds();
  }
});



// WEBPACK FOOTER //
// ./messaging/models/message.js